/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Notes_HighlightInputs */

const en_heading_notes_highlight = /** @type {(inputs: Heading_Notes_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writings`)
};

const ar_heading_notes_highlight = /** @type {(inputs: Heading_Notes_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كتابات`)
};

const bn_heading_notes_highlight = /** @type {(inputs: Heading_Notes_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লেখা`)
};

const de_heading_notes_highlight = /** @type {(inputs: Heading_Notes_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte`)
};

const es_heading_notes_highlight = /** @type {(inputs: Heading_Notes_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escritos`)
};

const fr_heading_notes_highlight = /** @type {(inputs: Heading_Notes_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écrits`)
};

const pt_heading_notes_highlight = /** @type {(inputs: Heading_Notes_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escritos`)
};

const zh_heading_notes_highlight = /** @type {(inputs: Heading_Notes_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`著作`)
};

const tr_heading_notes_highlight = /** @type {(inputs: Heading_Notes_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazılar`)
};

const ru_heading_notes_highlight = /** @type {(inputs: Heading_Notes_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сочинения`)
};

const pl_heading_notes_highlight = /** @type {(inputs: Heading_Notes_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pisma`)
};

/**
* | output |
* | --- |
* | "Writings" |
*
* @param {Heading_Notes_HighlightInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_notes_highlight = /** @type {((inputs?: Heading_Notes_HighlightInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Notes_HighlightInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_notes_highlight(inputs)
	if (locale === "bn") return bn_heading_notes_highlight(inputs)
	if (locale === "de") return de_heading_notes_highlight(inputs)
	if (locale === "es") return es_heading_notes_highlight(inputs)
	if (locale === "fr") return fr_heading_notes_highlight(inputs)
	if (locale === "pt") return pt_heading_notes_highlight(inputs)
	if (locale === "zh") return zh_heading_notes_highlight(inputs)
	if (locale === "tr") return tr_heading_notes_highlight(inputs)
	if (locale === "ru") return ru_heading_notes_highlight(inputs)
	if (locale === "pl") return pl_heading_notes_highlight(inputs)
	return en_heading_notes_highlight(inputs)
});